import React from "react";
import { Text4, Text5, Text3, Text6, Text7 } from "../../Common";
import { CardContentWrapper, CardWrapper } from "./styles";
import DownArrow from "../../../Assets/down-arrow.png";

const CardContent = ({
  imageUrl,
  title,
  title2,
  description,
  imageSize,
  fontSize,
  expandIcon
}) => {
  return (
    <CardContentWrapper imageSize={imageSize}>
      <div className={"sec1"}>
        {expandIcon && <img src={DownArrow} className={'expandIcon'}/> }
        <img src={imageUrl} alt="" />
        <div className={"sec2"}>
          {fontSize === "large" ? (
            <>
              <Text5
                align={"left"}
                color={"white"}
                weight={700}
                margin={"0px auto"}
              >
                {title}
              </Text5>
              <Text6
                align={"left"}
                color={"rgba(255, 255, 255, 0.41)"}
                margin={"3px auto"}
              >
                {title2}
              </Text6>
            </>
          ) : (
            <>
              <Text6
                align={"left"}
                color={"white"}
                weight={700}
                margin={"0px auto"}
              >
                {title}
              </Text6>
              <Text7
                align={"left"}
                color={"rgba(255, 255, 255, 0.41)"}
                margin={"3px auto"}
              >
                {title2}
              </Text7>
            </>
          )}
        </div>
      </div>
      {fontSize === "large" ? (
        <Text6
          align={"left"}
          color={"white"}
          margin={"12px auto"}
          lineHeight={"20px"}
          weight={500}
        >
          {description}
        </Text6>
      ) : (
        <Text7
          align={"left"}
          color={"white"}
          margin={"12px auto"}
          lineHeight={"15px"}
          weight={500}
        >
          {description}
        </Text7>
      )}
    </CardContentWrapper>
  );
};

const CardOne = ({
  imageUrl,
  title,
  title2,
  description,
  imageSize,
  fontSize,
  expandIcon
}) => {
  return (
    <CardWrapper>
      <CardContent
        imageUrl={imageUrl}
        title={title}
        title2={title2}
        description={description}
        imageSize={imageSize}
        fontSize={fontSize}
        expandIcon={expandIcon}
      />
    </CardWrapper>
  );
};

export default CardOne;
